var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alerts-wrapper"},[_c('div',{staticClass:"alerts-wrapper__icon"},[_c('v-img',{attrs:{"width":"24px","height":"24px","src":require("@/assets/icons/svg/alert.svg")}})],1),_c('div',{staticClass:"alerts-wrapper__text"},[_vm._v(" These changes will be applied to the items which use custom fields ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }